import { client, getUrl } from "utils";

export const getSiteGroupsRequest = (filterParams) => client.get(getUrl("site-groups", filterParams));

export const createSiteGroupRequest = (data) => client.post("site-groups", data);

export const editSiteGroupRequest = (data) => client.put(`site-group/${data.code}`, data);

export const deleteSiteGroupRequest = (code) => client.delete(`site-group/${code}`);

export const getBranchesRequest = (siteGroupCode) => client.get(getUrl("branches", {"site_group_code": siteGroupCode}))
    .then((response) => ({ [siteGroupCode]: response.branches }));